import SnackbarType from "@/types/enums/snackbar-type";
import {ref} from "vue";

class SnackbarService {
  public snackbarVisible = ref(false);
  public snackbarMessage = ref("");
  public snackbarColor = ref(SnackbarType.SUCCESS);

  public show(message: string, type: SnackbarType): void {
    this.snackbarMessage.value = message;
    this.snackbarColor.value = type;
    this.snackbarVisible.value = true;
  }
}

export default new SnackbarService();
